import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { InformationTabComponent } from './tabs/information-tab/information-tab.component';

export enum TabEnum {
  INFORMATION = 'information-tab',
}

export const EmspBoEmspUserDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () =>
      [
        {
          title: t('$.emsp-bo-emsp-user-details.information.title'),
          icon: 'users-01',
          key: TabEnum.INFORMATION,
        },
      ] as const,
    [t],
  );

  const { tab: currentTab, setTab: setCurrentTab } = useTabQuery(
    TabEnum.INFORMATION,
    extractTabKeys(tabs),
  );

  const renderTab = useMemo(() => {
    switch (currentTab) {
      case TabEnum.INFORMATION:
      default:
        return <InformationTabComponent />;
    }
  }, [currentTab]);

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Tabs
        currentTab={currentTab}
        onTabClick={(tab) => setCurrentTab(tab)}
        elements={tabs}
      />
      {renderTab}
    </>
  );
};
